export default __webpack_public_path__ + "static/media/beets-icon-large.df481e64.png";